const formatterMoney = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  currency: 'EUR',
  style: 'currency'
})

const formatterInt = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

const formatterDate = new Intl.DateTimeFormat('de-DE', {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit'
})

export default {
  filters: {
    dateFormatter (val) {
      // new Date("2019-07-01 19:24:33")
      try {
        let fixedVal = val.substr(0, 10) + 'T' + val.substr(11)
        let res = formatterDate.format(new Date(fixedVal)) // formatterDate.format(new Date(val.substr(0, 4), val.substr(6, 2), val.substr(8, 2), val.substr(11, 2), val.substr(13, 2), val.substr(15, 2)))
        return res
      } catch (e) {
        console.error(e)
        return val
      }
    },
    money (val) {
      return formatterMoney.format(val)
    },
    quantity (val) {
      return formatterInt.format(val)
    }
  }
}
